import { render, staticRenderFns } from "./TCB.vue?vue&type=template&id=18e78c68&"
import script from "./TCB.vue?vue&type=script&lang=js&"
export * from "./TCB.vue?vue&type=script&lang=js&"
import style0 from "./TCB.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports